export default {
  title: {
    frontpage: 'Vigo kodeverk'
  },
  tablelist: {
    type: {
      table: 'Table',
      table_no_xml: 'Table, not in XML',
      logs: 'Logs',
      relations: 'Relations',
      road_to_coc: 'Road to competence'
    },
    reasoncodes: 'Reasoncodes',
    examforms: 'Examforms',
    examgrading: 'Exam-grading',
    courses: 'Courses'
  },
  datatable: {
    header: {
      distrPlan: 'Distributionplan',
      actualDistrPlan: 'Actual distributionplan',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      forImport: 'For import?',
      expired: 'Expired?',
      name: 'Name',
      longName: 'Long name',
      course: {
        courseCode: 'Coursecode',
        courseType: 'Coursetype'
      }
    },
    tooltip: {
      compactrows: 'Compact rows',
      normalrows: 'Normal rows',
      filter: 'Filter data',
      pickcolumns: 'Pick columns',
      downloadxlsx: 'Download excel-file'
    }
  },
  route: {
    list: 'List',
    course: 'Course'
  },
  $vuetify: {
    close: 'Close',
    dataIterator: {
      pageText: '{0}-{1} of {2}',
      noResultsText: 'No matching records found',
      loadingText: 'Loading items...'
    },

    dataTable: {
      itemsPerPageText: 'Rows per page:',
      ariaLabel: {
        sortDescending: ': Sorted descending. Activate to remove sorting.',
        sortAscending: ': Sorted ascending. Activate to sort descending.',
        sortNone: ': Not sorted. Activate to sort ascending.'
      },
      sortBy: 'Sort by'
    },
    dataFooter: {
      itemsPerPageText: 'Items per page:',
      itemsPerPageAll: 'All',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      firstPage: 'First page',
      lastPage: 'Last page',
      pageText: '{0}-{1} / {2}'
    },
    datePicker: {
      itemsSelected: '{0} selected'
    },
    noDataText: 'No data available',
    carousel: {
      prev: 'Previous visual',
      next: 'Next visual'
    },
    calendar: {
      moreEvents: '{0} more'
    },
    fileInput: {
      counter: '{0} files',
      counterSize: '{0} files ({1} in total)'
    }
  }
}
